<p-card class="flex grow" styleClass="grow">
  <ng-template #header>
    <div class="p-card-title px-4 pt-2 flex flex-row min-h-14">
      <div *ngIf="title" class="grow content-center">
        {{ title | translate }}
      </div>
      <div *ngIf="showChange" class="content-center">
        <p-button
          [label]="'miscellaneous.action.change' | translate"
          variant="text"
          severity="secondary"
          (click)="op.toggle($event); onChangeUsers()"
        />

        <!-- <p-button (click)="op.toggle($event)" icon="pi pi-share-alt" label="Share" /> -->
        <p-popover #op>
          <div class="flex flex-col gap-4 w-[25rem]">
            <div>
              <!--<span
                class="font-medium text-surface-900 dark:text-surface-0 block mb-2"
                >Share this document</span
              >
              <p-inputgroup>
                <input
                  pInputText
                  value="https://primeng.org/12323ff26t2g243g423g234gg52hy25XADXAG3"
                  readonly
                  class="w-[25rem]"
                />
                <p-inputgroup-addon>
                  <i class="pi pi-copy"></i>
                </p-inputgroup-addon>
              </p-inputgroup> -->
            </div>
            <div>
              <span
                class="font-medium text-surface-900 dark:text-surface-0 block mb-2"
                >{{ "miscellaneous.searchUsers.label" | translate }}</span
              >
              <div class="flex gap-2">
                <p-select
                  [size]="'small'"
                  [options]="availableUsers"
                  [(ngModel)]="selectedUser"
                  [disabled]="availableUsers === undefined"
                  optionLabel="userPrincipalName"
                  [filter]="true"
                  class="w-full md:w-56 flex-1"
                >
                  <ng-template let-item #item>
                    <div class="flex flex-row gap-2 max-w-80 overflow-hidden">
                      <p-avatar
                        [label]="
                          getUserAvatarInitials(
                            item.displayName,
                            item.email || item.userPrincipalName
                          )
                        "
                        [ngStyle]="{
                          'background-color': getUserAvatarColor(
                            item.displayName,
                            item.email || item.userPrincipalName
                          ),
                          color: '#ffffff',
                        }"
                        [pTooltip]="getAvatarTooltip(item)"
                        size="large"
                        shape="circle"
                        class="shrink-0 text-base"
                      />
                      <div class="flex flex-col overflow-hidden">
                        <div
                          class="overflow-hidden text-ellipsis whitespace-nowrap"
                        >
                          {{ item.userPrincipalName }}
                        </div>
                        <div
                          class="text-muted-color overflow-hidden text-ellipsis whitespace-nowrap"
                        >
                          {{ item.id }}
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-select>
                <button
                  pButton
                  label="Add User"
                  icon="pi pi-users"
                  (click)="onAddUser()"
                  [disabled]="!selectedUser"
                ></button>
                <!--<p-inputgroup>
                  <input pInputText />
                  <p-select
                    [options]="availableUsers"
                    [(ngModel)]="selectedUser"
                    optionLabel="userPrincipalName"
                    [filter]="true"
                    class="w-full md:w-56"
                  />

                  <button pButton label="Add User" icon="pi pi-users"></button>
                </p-inputgroup> -->
              </div>
            </div>
            <div>
              <span
                class="font-medium text-surface-900 dark:text-surface-0 block mb-2"
                >{{ "miscellaneous.assignedUsers.label" | translate }}</span
              >
              <ul
                class="list-none p-0 m-0 flex flex-col gap-4 overflow-auto max-h-60 pr-1"
              >
                @for (item of items; track item) {
                  <div class="flex flex-row gap-2">
                    <p-avatar
                      [label]="
                        getUserAvatarInitials(
                          item.displayName,
                          item.email || item.userPrincipalName
                        )
                      "
                      [ngStyle]="{
                        'background-color': getUserAvatarColor(
                          item.displayName,
                          item.email || item.userPrincipalName
                        ),
                        color: '#ffffff',
                      }"
                      [pTooltip]="getAvatarTooltip(item)"
                      size="large"
                      shape="circle"
                      class="shrink-0 text-base"
                    />
                    <div class="flex flex-col overflow-hidden">
                      <div
                        class="overflow-hidden text-ellipsis whitespace-nowrap"
                      >
                        {{ item.userPrincipalName }}
                      </div>
                      <div
                        class="text-muted-color overflow-hidden text-ellipsis whitespace-nowrap"
                      >
                        {{ item.id }}
                      </div>
                    </div>
                    <div *ngIf="userType !== 'owner'">
                      <p-button
                        [severity]="'danger'"
                        icon="pi pi-trash"
                        (click)="onDeleteUser(item)"
                        class="ml-2"
                      />
                    </div>
                  </div>
                }
              </ul>
            </div>
          </div>
        </p-popover>
      </div>
    </div>
  </ng-template>
  <div class="card flex justify-center grow w-full">
    <p-avatar-group>
      <ng-container *ngFor="let item of items; let index = index">
        <p-avatar
          *ngIf="index < maxDisplay"
          [label]="
            getUserAvatarInitials(
              item.displayName,
              item.email || item.userPrincipalName
            )
          "
          [ngStyle]="{
            'background-color': getUserAvatarColor(
              item.displayName,
              item.email || item.userPrincipalName
            ),
            color: '#ffffff',
          }"
          [pTooltip]="getAvatarTooltip(item)"
          size="large"
          shape="circle"
          class="shrink-0 text-base"
        />
      </ng-container>

      <p-avatar
        *ngIf="items.length > maxDisplay"
        [label]="'+' + (items.length - maxDisplay)"
        shape="circle"
        size="large"
      />
    </p-avatar-group>
  </div>
</p-card>
